export default {
    xs: '0px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
};
//# sourceMappingURL=defaultScreens.js.map